"use client";

import { Col, DatePicker, Form, Input, Row, Select, Typography } from "antd";
import { BOM } from "../../../services/definedMethod";

import dayjs from "dayjs";
import { labelConfig, staticConfig } from "../serviceProvider.config";
import styles from "../../../assets/styles/styles";

const { Title, Paragraph } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const dateFormat = "DD-MM-YYYY";

const GeneralInformationForm = ({
  onFinish,
  form,
  initialValues,
  fieldOfficerData,
  isCreateScreen,
  userData,
  currencies,
  isActive,
  legalFormData,
  officeData,
  legalOption,
  customerTypeData,
  genderData,
  disabledAfterCurrentDate,
  disableDaysBeforeToday,
  clientNonPersonMainBusinessLineOptions,
  clientNonPersonConstitutionOptions,
  customerList,
  agentType,
}) => {
  const superAgentOptions = customerList
    ?.filter((c) => c.agentType === "SUPER_AGENT")
    .map((c) => ({ label: c.name, value: c.id }));
  // && c?.status?.toLowerCase() === "active"

  const agentMerchantOptions = customerList
    ?.filter((c) => c.agentType === "AGENT")
    .map((c) => ({ label: c.name, value: c.id }));

  // const agentMerchantOptions = customerList
  // ?.filter((c) => c.agentType === "AGENT" || c.agentType === "MERCHANT")
  // .map((c) => ({ label: c.name, value: c.id }));

  return (
    <div className="form-section">
      <h2 style={{ margin: 0, marginBottom: 50, fontSize: "24px" }}>
        {labelConfig.generalInfo}
      </h2>
      {/* <p style={{ marginTop: "5px", color: "#6b7280" }}>
        Retrieve customer info
      </p> */}

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ ...initialValues, initiatedBy: userData.username }}
      >
        <Row>
          {/* <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.customerType}
              name="clientTypeId"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.customerType),
                },
              ]}
            >
              <Select
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  `${labelConfig.customerType}`,
                  "select"
                )}
                options={customerTypeData}
                showSearch
              />
            </Form.Item>
          </Col> */}

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.agentType}
              name="agentType"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.agentType),
                },
              ]}
            >
              <Select
                style={{ height: "44px" }}
                placeholder="Select Agent Type"
                options={staticConfig.agentTypeData}
                showSearch
              />
            </Form.Item>
          </Col>

          {/* CONDITIONAL FIELDS START HERE */}

          {/* Case 1: If Agent or Merchant is selected, show Super Agent dropdown */}
          {(agentType === "AGENT" || agentType === "MERCHANT") && (
            <Col span={12}>
              <Form.Item
                label={labelConfig.superAgent}
                name="superAgentId"
                // rules={[
                //   { required: true, message: "Please select a Super Agent" },
                // ]}
              >
                <Select
                  style={{ height: "44px" }}
                  placeholder="Select Super Agent to attach"
                  options={superAgentOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
          )}

          {/* Case 2: If Super Agent is selected, show Multi-select for Agents/Merchants */}
          {agentType === "SUPER_AGENT" && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label="Assign Agents"
                name="listOfAgents"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please assign at least one agent",
                //   },
                // ]}
              >
                <Select
                  mode="multiple"
                  style={{ width: "100%", height: "44px" }}
                  placeholder="Select multiple agents"
                  options={agentMerchantOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
          )}
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.legalForm}
              name="legalFormId"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.legalForm),
                },
              ]}
            >
              <Select
                style={{ height: "44px" }}
                className="read-only-select"
                placeholder={BOM.handlePlaceholderMsg(
                  `${labelConfig.legalForm}`,
                  "select",
                )}
                options={legalFormData}
                showSearch
                disabled={!isCreateScreen}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.branch}
              name="officeId"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.branch),
                },
              ]}
            >
              <Select
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  `${labelConfig.branch}`,
                  "select",
                )}
                options={officeData}
                showSearch
              />
            </Form.Item>
          </Col>
          {legalOption === 2 && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.businessName}
                name="fullname"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.businessName),
                  },
                ]}
              >
                <Input
                  style={{ height: "44px" }}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.businessName,
                  )}
                />
              </Form.Item>
            </Col>
          )}
          {!(legalOption === 2) && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.firstName}
                  name="firstname"
                  rules={BOM.fieldRules("firstName", true)}
                >
                  <Input
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.firstName,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.middleName}
                  name="middlename"
                  rules={BOM.fieldRules("middleName", false)}
                >
                  <Input
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.middleName,
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.lastName}
                  name="lastname"
                  rules={BOM.fieldRules("lastName", true)}
                >
                  <Input
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.lastName)}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.dateOfBirth}
                  name="dateOfBirth"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.dateOfBirth),
                      validator: (_, value) => {
                        const result = BOM.validateMinimumAge(value, 18);
                        if (!result.valid) {
                          return Promise.reject(new Error(result.message));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <DatePicker
                    // defaultValue={defaultValue}
                    disabledDate={disabledAfterCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.dateOfBirth,
                      "select",
                    )}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.gender}
                  name="genderId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.gender),
                    },
                  ]}
                >
                  <Select
                    style={{ height: "44px" }}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.gender,
                      "select",
                    )}
                    options={genderData}
                  />
                </Form.Item>
              </Col>
            </>
          )}
          {BOM.HasPermission("ACTIVATE_CLIENT") && isCreateScreen && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.status} name="active">
                <Select
                  style={{ height: "44px" }}
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.status}`,
                    "select",
                  )}
                  options={staticConfig.statusData}
                  showSearch
                />
              </Form.Item>
            </Col>
          )}
          {isActive && isCreateScreen && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.activationDate}
                name="activationDate"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.activationDate),
                  },
                ]}
              >
                <DatePicker
                  disabledDate={disabledAfterCurrentDate}
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.activationDate,
                    "select",
                  )}
                  style={{ width: "100%", height: "44px" }}
                />
              </Form.Item>
            </Col>
          )}
          {legalOption === 2 && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.incorporationDate}
                  name="dateOfBirth"
                  // rules={[
                  //   {
                  //     required: idType === 2 ? false : true,
                  //     message: BOM.CheckReqFld(labelConfig.incorporationDate),
                  //   },
                  // ]}
                >
                  <DatePicker
                    disabledDate={disabledAfterCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.incorporationDate,
                      "select",
                    )}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.incorporationValidUntil}
                  name="incorpValidityTillDate"
                  // rules={[
                  //   {
                  //     required: idType === 2 ? false : true,
                  //     message: BOM.CheckReqFld(
                  //       labelConfig.incorporationValidUntil
                  //     ),
                  //   },
                  // ]}
                >
                  <DatePicker
                    disabledDate={disableDaysBeforeToday}
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.incorporationValidDate,
                      "select",
                    )}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.constitution}
                  name="constitutionId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.constitution),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.constitution,
                      "select",
                    )}
                    options={clientNonPersonConstitutionOptions}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.mainBusinessLine}
                  name="mainBusinessLineId"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(labelConfig.mainBusinessLine),
                  //   },
                  // ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.mainBusinessLine,
                      "select",
                    )}
                    options={clientNonPersonMainBusinessLineOptions}
                    style={{ width: "100%", height: "44px" }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                legalOption === 2
                  ? labelConfig.businessRegistrationNumber
                  : labelConfig.externalID
              }
              name={
                legalOption === 2 ? "businessRegistrationNumber" : "externalId"
              }
              // name="externalId"
              rules={[
                {
                  required: legalOption === 2 ? true : false,
                  validator(_, value) {
                    if (legalOption === 2 && !value) {
                      return Promise.reject(
                        new Error("Business Registration Number is required"),
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  legalOption === 2
                    ? labelConfig.businessRegistrationNumber
                    : labelConfig.externalID,
                )}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.tradingName}
              name="tradingName"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.tradingName),
                },
              ]}
            >
              <Input
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(labelConfig.tradingName)}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.taxIDNumber}
              name="taxIdentificationNumber"
              // name="incorpNumber"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.taxIDNumber),
                },
              ]}
            >
              <Input
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(labelConfig.taxIDNumber)}
                // style={styles.ofInputFieldNumber}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.businessDecription}
              name="businessDescription"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.businessDecription),
                },
              ]}
            >
              <Input
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.businessDecription,
                )}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.natureOfBusiness}
              name="natureOfBusiness"
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.natureOfBusiness),
                },
              ]}
            >
              <Input
                style={{ height: "44px" }}
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.natureOfBusiness,
                )}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default GeneralInformationForm;
